module.exports = __webpack_public_path__ + "img/Group 110.c8d22574.png";